import { useState, useRef } from "react";
import { createPortal } from "react-dom";

interface IProps {
  text: string
  children: React.ReactNode
}

const Tooltip = ({ text, children }: IProps) => {
  const [isVisible, setIsVisible] = useState(false);
  const [tooltipPosition, setTooltipPosition] = useState({ top: 0, left: 0 });
  const triggerRef = useRef<HTMLDivElement>(null);

  const showTooltip = () => {
    if(triggerRef?.current) {
      const rect = triggerRef?.current.getBoundingClientRect();
      setTooltipPosition({
        top: rect.bottom + window.scrollY + 8, // khoảng cách 8px bên dưới
        left: rect.left + rect.width / 2, // canh giữa
      });
      setIsVisible(true);
    }
  };

  const hideTooltip = () => {
    setIsVisible(false);
  };

  return (
    <>
      <div
        ref={triggerRef}
        onMouseEnter={showTooltip}
        onMouseLeave={hideTooltip}
        className="inline-block"
      >
        {children}
      </div>

      {isVisible &&
        createPortal(
          <div
            style={{
              top: tooltipPosition.top,
              left: tooltipPosition.left,
              transform: "translateX(-50%)",
            }}
            className="fixed bg-gray-800 text-white text-sm rounded px-2 py-1 shadow-lg whitespace-nowrap z-50"
          >
            {text}
          </div>,
          document.body
        )}
    </>
  );
};

export default Tooltip;